module.exports = __webpack_public_path__ + "static/media/bg.af9c1b0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-1/bg.jpg
// module id = 687
// module chunks = 0